function buildMenu (allowed) {
  if (allowed == null || allowed.includes('Policy'))  {
    return [
    {
      title: 'Policy',
      icon: 'mdi-card-account-details-outline',
      items: [
        {
          icon: 'mdi-file-document-multiple-outline',
          title: 'Documents',
          path: '/PolDocs'
        }
      ]
    }
  ] } else return []
}

export default buildMenu